import * as React from 'react';

import {
	CheckoutOrderFragment,
	CheckinOrderFragment,
	FlightFragment,
	SegmentFragment,
	PassengerFragment,
	CheckinPassengerFragment,
	AdditionalServicesFragment,
	OrderSelectedServices,
	GetAccountInfoQuery
} from '@websky/graphql';

import { PassengerState } from '../Checkout/store/passengers/reducers';
import { SelectedServicesState } from '../Checkout/store/selectedServices/reducers';
import { LoadingServicesParamsState } from '../Checkout/store/loadingServicesParams/reducers';
import { SelectedBaggageItem } from '../BaggageService/types';

import { ServicePayload } from '../Checkout/store/selectedServices/actions';

export interface CardExtrasProviderProps {
	userInfo?: GetAccountInfoQuery['CurrentUser'];
	updateUser?: () => void;
	isCheckinAvailable?: boolean;
}

export type CardExtrasContextSelectors = {
	order: CheckoutOrderFragment | CheckinOrderFragment;
	flight: FlightFragment;
	segments: SegmentFragment[];
	travellers: (PassengerFragment | CheckinPassengerFragment)[];
	additionalServices: AdditionalServicesFragment;
	passengers: PassengerState[];
	selectedServices: SelectedServicesState;
	brandIncludedBaggage: SelectedBaggageItem[];
	loadingServiceParams?: LoadingServicesParamsState;
};

export type CardExtrasContextState = {
	isLoading?: boolean;
	onSaveServicesRequest: (payload: OrderSelectedServices) => Promise<CheckoutOrderFragment | CheckinOrderFragment>;
	onSaveServices: (payload: ServicePayload[]) => void;
	onAddServices: (payload: ServicePayload[]) => void;
	onRemoveServices: (payload: ServicePayload[]) => void;
};

export type CardExtrasContextProps = CardExtrasProviderProps & CardExtrasContextSelectors & CardExtrasContextState;

const CardExtrasContext = React.createContext<CardExtrasContextProps>(null!);
const CardExtrasProvider = CardExtrasContext.Provider;

const useCardExtras = () => React.useContext<CardExtrasContextProps>(CardExtrasContext);

export { CardExtrasContext, CardExtrasProvider, useCardExtras };
